import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderSlice } from 'redux/reducers'
import { getHashSearchParam } from 'utils'
import { useEffect } from 'react'

export const ToggleIcon = ({ setHideNav }) => {
    const dispatch = useDispatch()
    const outlineBorder = useSelector(state => state.HeaderSlice.outlineBorder)
    const flag = useSelector(state => state.HeaderSlice.flag)
    const outlineBorderChangeProject = getHashSearchParam('outlineBorder')

    useEffect(() => {
        if (outlineBorderChangeProject) {
            const result = outlineBorderChangeProject === 'true' ? true : false
            const origin = window.location.origin
            window.history.pushState(null, '', origin)
            dispatch(HeaderSlice.actions.changepOutlineBorder(result))
        }
    }, [outlineBorderChangeProject])

    return (
        <div
            className={classnames('toggleIcon', {
                'toggleIcon-active': outlineBorder,
            })}
            onClick={() => {
                dispatch(HeaderSlice.actions.changepOutlineBorder(!outlineBorder))
                dispatch(HeaderSlice.actions.changeMenuStyle(!flag))
                dispatch(HeaderSlice.actions.changeOnceFlagStyle(true))
            }}
        >
            <div className='one'></div>
            <div className='two'></div>
            <div className='three'></div>
        </div>
    )
}
